import { Component, OnInit } from '@angular/core';
import {AhmService} from '../../services/ahm.service';
import {HttpClient} from '@angular/common/http';
import {TranslateService} from '../../services/translate.service';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.css']
})
export class HomePageComponent implements OnInit {

  version = 'eng';
  homePageLogo = '';
  alphabet = '';
  human = '';
  mind = '';
  subtitle = '';
  authors = '';
  // login form
  loginform = '';
  mobile = '';
  login = '';
  close = '';
  paysub = '';
  // social
  rideroButtonLink = '';
  rideroButtonImage = '';
  amazonButtonLink = '';
  amazonButtonImage = '';
  boomstarterButtonLink = '';
  boomstarterButtonImage = '';
  instagramButtonLink = '';
  instagramButtonImage = '';
  vkButtonLink = '';
  vkButtonImage = '';
  youtubeButtonLink = '';
  youtubeButtonImage = '';
  fbButtonLink = '';
  fbButtonImage = '';

  // right panel control
  changeLanguageRUColor = 'grey';
  changeLanguageENColor = 'black';

  // top menu - books
  navigationColor = 'white';
  navigationSize = 25; // size of contol elements font in pixeles
  navigationTextSize = 15;
  booksButtonMenuColor = 'white';
  aboutButtonMenuColor = 'white';
  rightButtonMenuColor = 'white';
  leftButtonMenuColor = 'white';
  centerButtonMenuColor = 'white';

  // mainPageDisplay = 'none';
  mainPageDisplay = 'block';
  loginFormDisplay = 'block';

  signedInSpan = '<b>Not Signed In</br>';
  signedInColor = 'red';
  signedInBgColor = 'yellow';
  hospitalPageDisplay = 'none';
  dynamicPageDisplay = 'block';
  selectedPage: string = '';

  ruImg = './assets/images/languages/ru_bw.png';
  enImg = './assets/images/languages/en_bw.png';


  constructor(private translate: TranslateService, private service: AhmService) { }

  ngOnInit() {
    AhmService.prototype.setHomeComponentLink(this);
    if ('ru' === this.translate.lang) {
      this.ruImg = './assets/images/languages/ru.png';
    }
    if ('en' === this.translate.lang) {
      this.enImg = './assets/images/languages/en.png';
    }
  }

  openLoginForm(){
    if ('<b>Not Signed In</br>' === this.signedInSpan) {
      this.service.showLoginForm();
    } else {
      // todo: visit cabinet
    }
  }

  /**
   * Set language for home page
   */
  setLanguage(version, img: HTMLImageElement) {
    img.style.opacity = '1';
    // TODO: chane if-else onto switch-case
    this.version = version;
    //console.log('translate site into language: ', version);
    if ('rus' === version) {
      // todo: show login page
      this.ruImg = './assets/images/languages/ru.png';
      this.enImg = './assets/images/languages/en_bw.png';
      this.translate.use('ru');
      // set book version
      this.service.setBookVersion('АЧП1');
      setTimeout(() => {
        this.service.showPage(1);
        this.service.showLoginForm();
        this.service.resetTopMenuSelections();
      });
    } else if ('eng' === version) {
      this.ruImg = './assets/images/languages/ru_bw.png';
      this.enImg = './assets/images/languages/en.png';
      this.translate.use('en');
      // set book version
      this.service.setBookVersion('AHM1');
      setTimeout(() => {
        this.service.showPage(1);
        this.service.showLoginForm();
        this.service.resetTopMenuSelections();
      });
    }
    // set language parameter in service
    this.service.setLanguageSiteVersion(version);
    // go to translated main page todo: later may upgrade navigation and translate page where user is
    // document.location.href = '/'; - loosing language parameter changing page

  }

  languageRuOver(img: HTMLImageElement) {
    if ('en' === this.translate.lang) {
      img.src = img.src.replace('_bw.png', '.png');
      img.style.opacity = '0.5';
    }
  }

  languageRuOut(img: HTMLImageElement) {
    if ('en' === this.translate.lang) {
      img.src = img.src.replace('.png', '_bw.png');
    }
    img.style.opacity = '1';
  }

  languageEnOver(img: HTMLImageElement) {
    if ('ru' === this.translate.lang) {
      img.src = img.src.replace('_bw.png', '.png');
      img.style.opacity = '0.5';
    }
  }

  languageEnOut(img: HTMLImageElement) {
    if ('ru' === this.translate.lang) {
      img.src = img.src.replace('.png', '_bw.png');
    }
    img.style.opacity = '1';
  }

}
